import {
    Authenticator, Flex, Grid,
} from "@aws-amplify/ui-react";
import React from "react";

import { Footer } from "./footer";
import { SignInHeader } from "./signin-header";
import { SignInFooter } from "./signin-footer";
import { I18n } from "aws-amplify";

const components = {
    SignIn: {
        Header: SignInHeader,
        Footer: SignInFooter
    },
    Footer
};

I18n.putVocabulariesForLanguage('en', {
    Username: 'Username',
    'Forgot your password?': 'Reset Password',
});

const formFields = {
    signIn: {
        username: {
            isRequired: true,
        },
        password: {
            isRequired: true,
        }
    },
}

export function Login() {
    return (
        <>
            <Grid >
                <Flex
                    justifyContent="center"
                >
                    <Authenticator components={components} formFields={formFields} hideSignUp={true}>
                        {({ signOut }) =>
                            <button onClick={signOut}>Sign out</button>
                        }
                    </Authenticator>
                </Flex>
            </Grid>
        </>
    );
}
